import { word } from "@modules/core/utils/i18n"
import { ProgramBundleForm, ProgramBundleFormProps } from "@modules/programBundle/components/programBundleForm"
import { ProgramBundleInfoResume } from "@modules/programBundle/components/programBundleInfoResume"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { useConfirmPopup } from "@modules/ui/components/popup/huConfirmPopup"

type navigateToProgramBundleFormProps = {
  programBundleFormProps?: ProgramBundleFormProps
  args?: SidebarNavigatorParams
}

export const useProgramBundleSidebar = () => {
  const { sidebarNavigateTo, hideSidebar } = useSidebar()
  const confirmPopup = useConfirmPopup()

  const navigateToProgramBundleForm = ({ programBundleFormProps, args }: navigateToProgramBundleFormProps) => {
    sidebarNavigateTo({
      content: <ProgramBundleForm {...programBundleFormProps} />,
      onHide: async () =>
        await new Promise<boolean>((resolve) => {
          confirmPopup.show({
            title: programBundleFormProps?.programBundle
              ? word("programBundle.form.cancelEdit.title")
              : word("programBundle.form.cancel.title"),
            message: programBundleFormProps?.programBundle
              ? word("programBundle.form.cancelEdit.message")
              : word("programBundle.form.cancel.message"),
            accept: async () => resolve(true),
            cancel: async () => resolve(false),
            footerProps: {
              align: true,
              confirmClassName: "flex-1",
              cancelClassName: "flex-1",
              footerClassName: "flex flex-row justify-content-around w-full",
            },
          })
        }),
      ...args,
    })
  }

  const navigateToProgramBundleResume = (
    programBundleId: string,
    editionAllowed: boolean,
    args?: SidebarNavigatorParams,
  ) => {
    sidebarNavigateTo({
      content: <ProgramBundleInfoResume programBundleId={programBundleId} editionAllowed={editionAllowed} />,
      ...args,
    })
  }

  return { hideSidebar, navigateToProgramBundleResume, navigateToProgramBundleForm }
}
